var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommandCenterActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8276 15.5863L16.7586 14.4829M18.5 19L16.7586 16.784M15.7931 18.4829L14.8276 16.5518M6.13794 8.55183L7.93104 9.65528M6.4138 6.06907L7.93104 7.58632M8.75863 5.79321L10 7.72425",
    stroke: "#1A73E8",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2428 13.2414L14.4152 4L12.3462 10.7586H17.5876L10.4152 20L12.3462 13.2414H7.2428Z",
    fill: "#1A73E8",
    stroke: "#1A73E8",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 8.55387 21.4153 5.47786 18.9349 3.46095C18.9556 3.47337 18.9772 3.48637 18.9999 3.5L19.7022 2.7977C22.3294 4.99896 24 8.30439 24 12C24 18.6274 18.6274 24 12 24C8.3044 24 4.99899 22.3294 2.79773 19.7023L3.5 19L3.43628 18.9044C5.45272 21.4023 8.53978 23 12 23ZM18.0694 1.64585C16.2888 0.599819 14.2144 0 12 0C5.37258 0 0 5.37258 0 12C0 14.0373 0.507691 15.956 1.40346 17.6365C1.584 17.5254 1.84009 17.3598 2.19962 17.0004C1.43263 15.5002 1 13.8006 1 12C1 5.92487 5.92487 1 12 1C14.0092 1 15.8926 1.53869 17.5137 2.47952C17.999 1.75149 18 1.75 18 1.75C18 1.75 17.9997 1.75041 18.0694 1.64585Z",
    fill: "#1A73E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandCenterActive);
export default __webpack_public_path__ + "static/media/Command_Center_Active.e214adb222bf397c257b460db8641b8e.svg";
export { ForwardRef as ReactComponent };